import { atomWithStorage } from 'sierra-client/state/storage'

export const newHomeOverride = atomWithStorage<null | boolean>('new-home-override', null)
